import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { TrainingProgramForm } from '@app/modules/forms/training/components/';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { TrainingProgramsTable } from '@app/modules/training/services/tables/training-programs/training-programs.table';
import { TrainingModuleMenuService } from '@app/modules/training/services/training-module-menu.service';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { TrainingProgram } from '@models/training/training-program.model';

@Component({
    templateUrl: './training-programs.template.html',
    styleUrls: ['./training-programs.style.scss'],
})
export class TrainingProgramsView implements OnInit {
    @ViewChild('confirmDeleteDialog', { static: true }) confirmDeleteDialog: DeprecatedConfirmationDialogComponent;
    @ViewChild('editForm') editForm: TrainingProgramForm;
    isLoading = true;
    program: TrainingProgram;

    constructor(
        public table: TrainingProgramsTable,
        protected router: Router,
        protected auth: AuthService,
        protected notify: NotifyService,
        public trainingModuleMenuService: TrainingModuleMenuService
    ) {
        this.table.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        this.table.reload();
    }

    get isEmpty(): boolean {
        return this.table.paginator.empty && !this.table.activeFilters.size && !this.table.paginator.search;
    }

    ngOnInit(): void {}

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;
        this.program = data as TrainingProgram;

        switch (menuItem.event) {
            case 'edit':
                this.onEdit();
                break;
            case 'delete':
                this.onDelete();
                break;
        }
    }

    onEdit(): void {
        this.router.navigate(['/training', 'programs', this.program.id, 'edit']);
    }

    async onDelete(): Promise<void> {
        const onDelete = await this.confirmDeleteDialog.show();

        if (!onDelete) {
            return;
        }

        this.isLoading = true;
        this.program
            .param('company', this.auth.company.id)
            .delete()
            .then(() => {
                this.notify.success('training.deleteTrainingSuccessMessage');
                this.isLoading = false;
                this.table.reload();
            })
            .catch((err) => {
                this.notify.error(err.message || 'training.deleteTrainingErrorMessage');
                this.isLoading = false;
            });
    }

    get deleteMessage(): string {
        if (this.program && this.program.enrolledCount === 1) {
            return 'training.deleteTrainingProgramConfirmation.singular';
        }

        if (this.program && this.program.enrolledCount > 1) {
            return 'training.deleteTrainingProgramConfirmation.plural';
        }

        return 'training.deleteTrainingProgramConfirmation.default';
    }
}
